import OspreyApiHelper from './helper'

export default class OspreyTags {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }

    static put(path, params) {
        return OspreyApiHelper.genericPut(path, params)
    }

    static post(path, params) {
        return OspreyApiHelper.genericPost(path, params.tag)
    }

    static delete(path) {
        return OspreyApiHelper.genericDelete(path)
    }
}



// WEBPACK FOOTER //
// src/services/osprey-api/api-tags.js